import { SITE, WHATSAPP_MESSAGES } from "@/config/site";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const siteUrl = () => {
  const env = (process.env.REACT_APP_SITE_URL || "").trim().replace(/\/$/, "");
  if (env) return env;
  if (typeof window !== "undefined") return window.location.origin;
  return "https://www.khozalandsa.co.za";
};

export const absUrl = (path = "/") => `${siteUrl()}${path.startsWith("/") ? path : `/${path}`}`;

export const whatsappLink = (key = "general", custom) => {
  const text = custom || WHATSAPP_MESSAGES[key] || WHATSAPP_MESSAGES.general;
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(text)}`;
};

export const quoteLink = ({ category, product, type } = {}) => {
  const params = new URLSearchParams();
  if (category) params.set("category", category);
  if (product) params.set("product", product);
  const base = type === "bulk" ? "/bulk-orders" : "/contact";
  const qs = params.toString();
  return `${base}${qs ? `?${qs}` : ""}#quote-form`;
};

// ---------------------------------------------------------------------------
// Analytics: pushes to dataLayer / gtag (only loaded after consent and only if an
// ID is configured) + anonymous first-party conversion counters.
// ---------------------------------------------------------------------------
const FIRST_PARTY = new Set(["whatsapp_click", "quote_cta_click", "phone_click", "email_click", "catalogue_cta_click", "gallery_request_similar"]);

export const track = (event, params = {}) => {
  try {
    const page = typeof window !== "undefined" ? window.location.pathname : "";
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, page_path: page, ...params });
    if (typeof window.gtag === "function") window.gtag("event", event, { page_path: page, ...params });
    if (FIRST_PARTY.has(event) && BACKEND_URL) {
      fetch(`${API}/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ event, page, label: params.label ? String(params.label).slice(0, 80) : undefined }),
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    /* analytics must never break the UI */
  }
};

export const ANALYTICS = {
  ga4: (process.env.REACT_APP_GA4_ID || "").trim(),
  gtm: (process.env.REACT_APP_GTM_ID || "").trim(),
};
export const analyticsConfigured = () => Boolean(ANALYTICS.ga4 || ANALYTICS.gtm);

let analyticsLoaded = false;
export const loadAnalytics = () => {
  if (analyticsLoaded || !analyticsConfigured()) return;
  analyticsLoaded = true;
  window.dataLayer = window.dataLayer || [];
  if (ANALYTICS.gtm) {
    window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(ANALYTICS.gtm)}`;
    document.head.appendChild(s);
  }
  if (ANALYTICS.ga4) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ANALYTICS.ga4)}`;
    document.head.appendChild(s);
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", ANALYTICS.ga4, { anonymize_ip: true });
  }
};

// Page-aware WhatsApp message + quote category (used by header, sticky bar, floating button).
export const CONTEXT_BY_PATH = {
  "/custom-tshirt-printing": { msg: "tshirts", category: "custom-clothing" },
  "/uniforms-embroidery": { msg: "uniforms", category: "uniforms-embroidery" },
  "/xhosa-cultural-products": { msg: "cultural", category: "xhosa-cultural" },
  "/corporate-gifts": { msg: "corporate", category: "corporate-gifts" },
  "/bulk-orders": { msg: "bulk", category: "bulk-group", type: "bulk" },
  "/personalised-gifts": { msg: "gifts", category: "personalised-gifts" },
  "/banners-stickers": { msg: "printing", category: "banners-stickers" },
  "/printing-branding": { msg: "general", category: "printing-branding" },
};
export const contextForPath = (pathname) => CONTEXT_BY_PATH[pathname] || { msg: "general" };
